import React from 'react'

import AddStaffForm from '../../modules/Staff/components/AddStaffForm'
export default function AddStaffPage() {
  return <AddStaffForm />
}
